import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { Tooltip } from "@msuite/ui/tooltip";
import { formatInvoiceAmount } from "@/components/incoming-invoices";
import type { PaymentPreview } from "./to-payment-previews";

/** Props Interface */
interface PaymentAmountCellProps {
	preview: PaymentPreview;
}

/**
 * What the file transfers for the invoice, with the outgoing invoices planned against it named in
 * a tooltip — or, when they cover the whole payment, that it is settled without a transfer line.
 */
export function PaymentAmountCell({ preview }: PaymentAmountCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Computed */
	const lessOffsets = t("incoming_invoices.payments.offsets.less_offsets", {
		numbers: preview.offsetNumbers.join(", "),
	});

	/** Guard */
	if (!preview.offsetNumbers.length) {
		return formatInvoiceAmount(preview.transferAmount, preview.currency);
	}
	if (preview.transferAmount === 0) {
		return (
			<Tooltip label={lessOffsets}>
				<Tag
					size="xs"
					color="blue"
					variant="plain"
				>
					{t("incoming_invoices.payments.offsets.offset_only")}
				</Tag>
			</Tooltip>
		);
	}

	/** Render */
	return (
		<Tooltip label={lessOffsets}>
			<span className="underline decoration-dotted">
				{formatInvoiceAmount(preview.transferAmount, preview.currency)}
			</span>
		</Tooltip>
	);
}
